<template>
  <v-checkbox
    class="mt-2"
    :input-value="original"
    v-on="$listeners"
    v-bind="{ ...$attrs, ...$props }"
    persistent-hint
    @change="$emit('save', +$event)"
  />
</template>

<script>
export default {
  name: 'ShopSettingsFieldCheckbox',
  props: {
    original: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
  data() {
    return {}
  },
}
</script>
